export const products = [
    {
        id: 1,
        weight: '450 мл',
        title: 'AOS средство для мытья посуды Crystal',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 50.76,
        image: require('@/assets/images/AOS.jpg'),
    },
    {
        id: 2,
        weight: '450 мл',
        title: 'AOS средство для мытья посуды Crystal',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 50.76,
        image: require('@/assets/images/AOS.jpg'),
    },
    {
        id: 3,
        weight: '450 мл',
        title: 'AOS средство для мытья посуды Crystal',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 50.76,
        image: require('@/assets/images/AOS.jpg'),
    },
    {
        id: 4,
        weight: '450 мл',
        title: 'AOS средство для мытья посуды Crystal',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 50.76,
        image: require('@/assets/images/AOS.jpg'),
    },
    {
        id: 5,
        weight: '450 мл',
        title: 'AOS средство для мытья посуды Crystal',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 50.76,
        image: require('@/assets/images/AOS.jpg'),
    },
    {
        id: 6,
        weight: '450 мл',
        title: 'AOS средство для мытья посуды Crystal',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 50.76,
        image: require('@/assets/images/AOS.jpg'),
    },
    {
        id: 7,
        weight: '450 мл',
        title: 'AOS средство для мытья посуды Crystal',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 50.76,
        image: require('@/assets/images/AOS.jpg'),
    },
    {
        id: 8,
        weight: '450 мл',
        title: 'AOS средство для мытья посуды Crystal',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 50.76,
        image: require('@/assets/images/AOS.jpg'),
    },
    {
        id: 9,
        weight: '450 мл',
        title: 'AOS средство для мытья посуды Crystal',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 50.76,
        image: require('@/assets/images/AOS.jpg'),
    },
    {
        id: 10,
        weight: '450 мл',
        title: 'AOS средство для мытья посуды Crystal',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 50.76,
        image: require('@/assets/images/AOS.jpg'),
    },
    {
        id: 11,
        weight: '15X28.8 г',
        title: 'ARIEL Автомат Гель СМС жидкое в растворимых капсулах Liquid Capsules Горный родник',
        barcode: '4604049097548',
        manufacturer: 'Grifon',
        brand: 'AOS',
        price: 70.76,
        image: require('@/assets/images/Ariel.jpg'),
    },
    {
        id: 12,
        weight: '15X28.8 г',
        title: 'ARIEL Автомат Гель СМС жидкое в растворимых капсулах Liquid Capsules Горный родник',
        barcode: '4604049097548',
        manufacturer: 'Grifon',
        brand: 'AOS',
        price: 70.76,
        image: require('@/assets/images/Ariel.jpg'),
    },
    {
        id: 13,
        weight: '15X28.8 г',
        title: 'ARIEL Автомат Гель СМС жидкое в растворимых капсулах Liquid Capsules Горный родник',
        barcode: '4604049097548',
        manufacturer: 'Grifon',
        brand: 'AOS',
        price: 70.76,
        image: require('@/assets/images/Ariel.jpg'),
    },
    {
        id: 14,
        weight: '15X28.8 г',
        title: 'ARIEL Автомат Гель СМС жидкое в растворимых капсулах Liquid Capsules Горный родник',
        barcode: '4604049097548',
        manufacturer: 'Grifon',
        brand: 'AOS',
        price: 70.76,
        image: require('@/assets/images/Ariel.jpg'),
    },
    {
        id: 15,
        weight: '15X28.8 г',
        title: 'ARIEL Автомат Гель СМС жидкое в растворимых капсулах Liquid Capsules Горный родник',
        barcode: '4604049097548',
        manufacturer: 'Grifon',
        brand: 'AOS',
        price: 70.76,
        image: require('@/assets/images/Ariel.jpg'),
    },
    {
        id: 16,
        weight: '15X28.8 г',
        title: 'ARIEL Автомат Гель СМС жидкое в растворимых капсулах Liquid Capsules Горный родник',
        barcode: '4604049097548',
        manufacturer: 'Grifon',
        brand: 'AOS',
        price: 70.76,
        image: require('@/assets/images/Ariel.jpg'),
    },
    {
        id: 17,
        weight: '15X28.8 г',
        title: 'ARIEL Автомат Гель СМС жидкое в растворимых капсулах Liquid Capsules Горный родник',
        barcode: '4604049097548',
        manufacturer: 'Grifon',
        brand: 'AOS',
        price: 70.76,
        image: require('@/assets/images/Ariel.jpg'),
    },
    {
        id: 18,
        weight: '15X28.8 г',
        title: 'ARIEL Автомат Гель СМС жидкое в растворимых капсулах Liquid Capsules Горный родник',
        barcode: '4604049097548',
        manufacturer: 'Grifon',
        brand: 'AOS',
        price: 70.76,
        image: require('@/assets/images/Ariel.jpg'),
    },
    {
        id: 19,
        weight: '15X28.8 г',
        title: 'ARIEL Автомат Гель СМС жидкое в растворимых капсулах Liquid Capsules Горный родник',
        barcode: '4604049097548',
        manufacturer: 'Grifon',
        brand: 'AOS',
        price: 70.76,
        image: require('@/assets/images/Ariel.jpg'),
    },
    {
        id: 20,
        weight: '15X28.8 г',
        title: 'ARIEL Автомат Гель СМС жидкое в растворимых капсулах Liquid Capsules Горный родник',
        barcode: '4604049097548',
        manufacturer: 'Нэфис',
        brand: 'AOS',
        price: 70.76,
        image: require('@/assets/images/Ariel.jpg'),
    },
    {
        id: 21,
        weight: '1500 г',
        title: 'BIMAX Порошок стиральный Автомат 100 пятен COMPACT',
        barcode: '4604049097548',
        manufacturer: 'Boyscout',
        brand: 'AOS',
        price: 48.76,
        image: require('@/assets/images/BiMAX.jpg'),
    },
    {
        id: 22,
        weight: '1500 г',
        title: 'BIMAX Порошок стиральный Автомат 100 пятен COMPACT',
        barcode: '4604049097548',
        manufacturer: 'Boyscout',
        brand: 'AOS',
        price: 48.76,
        image: require('@/assets/images/BiMAX.jpg'),
    },
    {
        id: 23,
        weight: '1500 г',
        title: 'BIMAX Порошок стиральный Автомат 100 пятен COMPACT',
        barcode: '4604049097548',
        manufacturer: 'Boyscout',
        brand: 'AOS',
        price: 48.76,
        image: require('@/assets/images/BiMAX.jpg'),
    },
    {
        id: 24,
        weight: '1500 г',
        title: 'BIMAX Порошок стиральный Автомат 100 пятен COMPACT',
        barcode: '4604049097548',
        manufacturer: 'Boyscout',
        brand: 'AOS',
        price: 48.76,
        image: require('@/assets/images/BiMAX.jpg'),
    },
    {
        id: 25,
        weight: '1500 г',
        title: 'BIMAX Порошок стиральный Автомат 100 пятен COMPACT',
        barcode: '4604049097548',
        manufacturer: 'Boyscout',
        brand: 'AOS',
        price: 48.76,
        image: require('@/assets/images/BiMAX.jpg'),
    },
    {
        id: 26,
        weight: '1500 г',
        title: 'BIMAX Порошок стиральный Автомат 100 пятен COMPACT',
        barcode: '4604049097548',
        manufacturer: 'Boyscout',
        brand: 'AOS',
        price: 48.76,
        image: require('@/assets/images/BiMAX.jpg'),
    },
    {
        id: 27,
        weight: '1500 г',
        title: 'BIMAX Порошок стиральный Автомат 100 пятен COMPACT',
        barcode: '4604049097548',
        manufacturer: 'Boyscout',
        brand: 'AOS',
        price: 48.76,
        image: require('@/assets/images/BiMAX.jpg'),
    },
    {
        id: 28,
        weight: '1500 г',
        title: 'BIMAX Порошок стиральный Автомат 100 пятен COMPACT',
        barcode: '4604049097548',
        manufacturer: 'Boyscout',
        brand: 'AOS',
        price: 48.76,
        image: require('@/assets/images/BiMAX.jpg'),
    },
    {
        id: 29,
        weight: '1500 г',
        title: 'BIMAX Порошок стиральный Автомат 100 пятен COMPACT',
        barcode: '4604049097548',
        manufacturer: 'Boyscout',
        brand: 'AOS',
        price: 48.76,
        image: require('@/assets/images/BiMAX.jpg'),
    },
    {
        id: 30,
        weight: '1500 г',
        title: 'BIMAX Порошок стиральный Автомат 100 пятен COMPACT',
        barcode: '4604049097548',
        manufacturer: 'Boyscout',
        brand: 'AOS',
        price: 48.76,
        image: require('@/assets/images/BiMAX.jpg'),
    },
];
